<template>
  <div
    class="tmetric-button play-list"
    :data-issue-name="issueName"
    :data-issue-id="issueId"
    :data-issue-url="issueURL"
    :data-project-name="projectName"
    :data-service-url="serviceURL"
    :style="buttonStyle"
  />
</template>

<script>
import { compact } from 'lodash'
import { mapGetters } from 'vuex'

import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'
import { PARTY_NAMESPACE } from '@/store/party'
import { RECORD_NAMESPACE } from '@/store/record'
import { legalCaseTitle } from '@/utilities'

export default {
  name: 'TmetricBoxComponent',

  data () {
    return {
      location: window.location,
    }
  },

  computed: {
    buttonStyle () {
      return this.showTmetricButton ? '' : 'display: none;'
    },

    currentLegalCaseTitle () {
      return legalCaseTitle(this.currentLegalCase, this.legalCaseTypesIds)
    },

    issueId () {
      return compact([this.currentRecord?.id, this.currentLegalCase?.id, this.peParty?.id]).join('/')
    },

    issueName () {
      const issueName = []

      issueName.push(
        this.currentRecord?.title,
        this.currentRecord?.id,
        this.currentLegalCase?.id ? `${this.currentLegalCaseTitle} (Case ID: ${this.currentLegalCase?.id})` : null,
        compact([this.peParty.first_name, this.peParty.last_name]).join(' ')
      )

      return compact(issueName).join(' - ')
    },

    issueURL () {
      return this.location.pathname
    },

    projectName () {
      if (!this.currentRecord?.id || !this.currentLegalCase?.id) return

      const legalCaseName = this.currentLegalCaseTitle?.split('-')[0].trim() || ''
      return `${legalCaseName} (${this.currentRecord.id}) (${this.currentLegalCase.id})`
    },

    serviceURL () {
      return this.location.origin
    },

    showTmetricButton () {
      return this.$route.meta?.tmetric?.enabled
    },

    ...mapGetters([
      'legalCaseTypesIds',
    ]),

    ...mapGetters(LEGAL_CASE_NAMESPACE, [
      'currentLegalCase',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),

    ...mapGetters(RECORD_NAMESPACE, [
      'currentRecord',
    ]),
  },

  watch: {
    showTmetricButton (newVal) {
      if (!newVal) return

      this.location = Object.assign({}, window.location)
    },
  },
}
</script>
